import { createSlice } from '@reduxjs/toolkit';

export type CompanyCustomer = 'App\\Models\\CompanyCustomer';
export type PrivateCustomer = 'App\\Models\\PrivateCustomer'
export type CustomerTypes = CompanyCustomer | PrivateCustomer;

export const customerTypes = {
  private: 'App\\Models\\PrivateCustomer' as PrivateCustomer,
  company: 'App\\Models\\CompanyCustomer' as CompanyCustomer,
};

export interface customerState {
  id: number | null;
  type: CustomerTypes | null;
  name: string | null;
  newlyCreated?: boolean;
}

export const nullCustomer = {
  id: null,
  type: null,
  name: null,
} as customerState;

export default function createCustomerSlice(initialState: customerState) {
  const customerSlice = createSlice({
    name: 'customer',
    initialState,
    reducers: {
      setCustomer(state, { payload }: { payload: customerState }) {
        return { ...state, ...payload };
      },
      unsetCustomer() {
        return { ...nullCustomer };
      },
    },
  });

  return customerSlice;
}

const customerSlice = createCustomerSlice(nullCustomer);
export const { setCustomer, unsetCustomer } = customerSlice.actions;
